import React from "react";
import { TargetIcon } from "assets";

export const TARGETS_PAGE = {
  ABSOLUTE_PATH: "/targets",
  TITLE: "Accelerate",
  ICON: <TargetIcon style={{ color: "#054254" }} />,
  renderMenu: true,
  configParameter: "target_setting_feature",
  hideInSidebarWhenDisabled: true,
};
